import React, { Children, isValidElement } from "react";
import { TableCell } from "@mui/material";

/**
 * Vários componentes de ação legados retornam `<TableCell>`.
 * Extrai apenas o conteúdo para reutilizar fora de tabelas (cards mobile).
 */
export function unwrapTableCellContent(
  node: React.ReactNode
): { content: React.ReactNode; sx?: unknown } {
  if (Array.isArray(node) && node.length === 1) {
    return unwrapTableCellContent(node[0]);
  }
  if (!isValidElement(node)) return { content: node };
  if (node.type === React.Fragment) {
    return unwrapTableCellContent((node as React.ReactElement).props?.children);
  }
  const anyType = node.type as { muiName?: string };
  const isMuiTableCell =
    node.type === TableCell || anyType?.muiName === "MuiTableCell";
  if (!isMuiTableCell) return { content: node };
  return {
    content: (node as React.ReactElement).props?.children,
    sx: (node as React.ReactElement).props?.sx,
  };
}

/** Separa barra de ações (1º filho) de modais/diálogos no mobile. */
export function splitLegacyRowActions(node: React.ReactNode): {
  actionBar: React.ReactNode;
  extras: React.ReactNode;
} {
  if (isValidElement(node) && node.type === React.Fragment) {
    const children = Children.toArray(
      (node as React.ReactElement).props?.children
    ).filter(Boolean);
    if (children.length === 0) return { actionBar: null, extras: null };
    const { content: actionBar } = unwrapTableCellContent(children[0]);
    const extras = children.length > 1 ? children.slice(1) : null;
    return { actionBar, extras };
  }
  const { content: actionBar } = unwrapTableCellContent(node);
  return { actionBar, extras: null };
}
